import xtend from 'xtend';
import namespace from '@nichoth/events/namespace';

const WS_EVENTS = ['update', 'add', 'delete'];
const HTTP_EVENTS = ['start', 'resolve', 'error'];

var httpCrud = [
    'assets',
    'categories',
    'encoders',
    'events',
    'facebookLive',
    'keywords',
    'locations',
    'metamarkers',
    'player',
    'technicians',
    'streamTargets',
    'transcript'
].reduce(function (acc, domain) {
    acc[domain] = {
        get: HTTP_EVENTS,
        edit: HTTP_EVENTS,
        delete: HTTP_EVENTS,
        add: HTTP_EVENTS
    };
    return acc;
}, {});

var EVENTS = namespace({
    ws: {
        _meta: ['open', 'close', 'error', 'trouble', 'reconnect'],
        // health: ['health'],
        events: ['add', 'update', 'delete', 'publish', 'unpublish',
            'start', 'stopping', 'stop', 'disconnected'],
        asset: WS_EVENTS,
        encoder: WS_EVENTS.concat(['connect', 'disconnected']),
        categories: WS_EVENTS,
        keywords: WS_EVENTS,
        location: WS_EVENTS,
        techs: WS_EVENTS,
        transcode: ['start', 'processing', 'complete'],
        thumbs: ['update', 'add'],
        metamarkers: ['add', 'update', 'delete'],
        message: ['add'],
        publish: ['publish', 'unpublish'],
        facebooklive: ['add', 'delete'],

        transcripts: ['completed', 'create'],
        eventdomrestrictions: ['upsert', 'delete'],
        eventaltdest: [
            'add', 'delete', 'update'
        ],

        Eventaltdest: [
            'start', 'stop',
        ],

        // Phalcon emits the controller name kebab-cased, hence the dashed key.
        // CC consumes these via the redux reducer (WEBSOCKET_DATA_<method>_<type>);
        // listing them here keeps the legacy bus demuxer from warning.
        'ad-studio-projects': ['upsert', 'delete']
    },

    http: xtend(httpCrud, {
        events: xtend(httpCrud.events, {
            start: HTTP_EVENTS,
            stop: HTTP_EVENTS,
            publish: HTTP_EVENTS,
            unpublish: HTTP_EVENTS,
        }),

        thumbs: {
            replace: HTTP_EVENTS
        },

        assets: xtend(httpCrud.assets, {
            getMiscAssets: HTTP_EVENTS,
            miscAssetToEvent: HTTP_EVENTS,
            editLink: HTTP_EVENTS
        }),

        analytics: {
            get: HTTP_EVENTS,
            getMostWatched: HTTP_EVENTS,
            getUpcomingEvents: HTTP_EVENTS
        },

        chat: {
            getModerators: HTTP_EVENTS,
            createModerator: HTTP_EVENTS,
            deleteModerator: HTTP_EVENTS,
            resetPassword: HTTP_EVENTS,
            updateChatSettings: HTTP_EVENTS
        },

        streamTargets: xtend(httpCrud.streamTargets, {
            getAltProviders: HTTP_EVENTS,
            getAltDestinations: HTTP_EVENTS
        }),

        transcript: {
            create: HTTP_EVENTS,
            delete: HTTP_EVENTS,
            resubmit: HTTP_EVENTS,
            setUseAsCaptions: HTTP_EVENTS,
            setUsetext: HTTP_EVENTS,
            getWebvtt: HTTP_EVENTS,
            getSrt: HTTP_EVENTS,
            getText: HTTP_EVENTS,
            getTranscriptInfo: HTTP_EVENTS,
            getTranscript: HTTP_EVENTS
        },

        restrictedDomains: {
            add: HTTP_EVENTS,
            delete: HTTP_EVENTS
        },

        audioDescription: {
            getProject: HTTP_EVENTS
        }
    })
})

export default EVENTS;
